<template>
  <b-modal ref="newMaskModal"
           :title="edit ? $t('evaluation.mask.edit') : $t('evaluation.mask.new')"
           :ok-title="$t('save')"
           :cancel-title="$t('cancel')"
           size="lg"
           centered
           @ok.prevent="save()">
    <form @submit.prevent="save()" @keydown="form.onKeydown($event)">
      <div class="form-group">
        <label for="maskname" class="col-form-label">{{ $t('evaluation.mask.name') }} :</label>
        <input id="maskname" v-model="form.title" type="text" class="form-control" maxlength="100">
        <form-error :form="form" field="title" />
      </div>
    </form>
    <div class="card">
      <div class="card-body">
        <div class="mask-tree-view">
          <CheckableTreeView v-if="maskData" ref="maskTreeView" :data="maskData" :form-type="formType" />
        </div>
      </div>
    </div>
    <div v-if="$refs.maskTreeView" class="text-right">
      {{ $t('evaluation.mask.information', [$refs.maskTreeView.state.checked, $refs.maskTreeView.state.children]) }}
    </div>
    <div slot="modal-footer" class="w-100">
      <Checkbox v-model="form.public" class="float-left with-buttons-on-right">{{ $t('evaluation.mask.submit') }}</Checkbox>
      <div class="float-right">
        <b-btn variant="secondary" @click="hide()">{{ $t('cancel') }}</b-btn>
        <b-btn variant="primary" @click="save()">{{ $t('save') }}</b-btn>
      </div>
    </div>
  </b-modal>
</template>

<script>

import Vue from 'vue'
import Form from 'vform'
import { mapGetters } from 'vuex'

export default {
  name: 'MaskModal',

  props: {
    formType: String
  },

  data: () => ({
    maskData: null,
    form: new Form({
      mask: '',
      creator_id: null,
      organization_id: null,
      public: false,
      form_type: '',
      title: '' // new Date(Date.now()).toDateString(),
    }),
    edit: false,
    mask_id: 0
  }),

  computed: {
    loadForm () {
      switch (this.formType) {
        case 'kid': this.data = JSON.parse(JSON.stringify(this.kid.entries))[0]
          break
        case 'young': this.data = JSON.parse(JSON.stringify(this.young.entries))[0]
          break
        case 'adult': this.data = JSON.parse(JSON.stringify(this.adult.entries))[0]
          break
      }
      this.resetModal()
    },
    ...mapGetters({
      kid: 'evaluations/kid',
      young: 'evaluations/young',
      adult: 'evaluations/adult',
      user: 'auth/user'
    })
  },

  mounted () {
    this.data = JSON.parse(JSON.stringify(this.young.entries))[0]
    this.resetModal()
  },

  methods: {

    hide () {
      this.$refs.newMaskModal.hide()
    },

    $_load (mask, index, data) {
      index.value++

      for (let i = 0; i < data.length; i++) {
        let node = data[i]
        let masked = mask.mask[index.value] == '0'

        Vue.set(node, 'masked', masked)

        if (masked) {
          index.value++
          continue
        } else {
          this.$_load(mask, index, node.children)
        }
      }
    },

    load (mask, data) {
      this.mask_id = mask.id
      this.form.mask = mask.mask
      this.form.creator_id = mask.creator_id
      this.form.organization_id = mask.organization_id
      this.form.public = mask.public
      this.form.title = mask.title
      this.form.public = !!mask.public

      if (mask.mask[0] == '0') {
        Vue.set(data[0], 'masked', true)
      }

      const index = { value: 0 }
      this.$_load(mask, index, data[0].children)
    },

    resetModal () {
      this.form.reset()
      this.maskData = [this.initTreeViewData(this.data)]
      this.form.title = new Date(Date.now()).toUserLocaleString(this)
      this.setEdit(false)
      if (this.$refs.maskTreeView) {
        this.$refs.maskTreeView.refresh()
      }
    },

    new () {
      this.loadForm
      this.resetModal()
      this.show()
    },

    editMask (mask, edit = true) {
      this.loadForm
      var tmpData = [this.initTreeViewData(this.data)]
      this.setEdit(edit)
      this.load(mask, tmpData)

      if (!edit) { this.form.title = '' }

      if (!this.maskData) { this.maskData = tmpData } else { Vue.set(this.maskData, 0, tmpData[0]) }

      if (this.$refs.maskTreeView) { this.$refs.maskTreeView.refresh() }
      this.show()
    },

    initTreeViewData (data) {
      data.masked = true
      if (data.children.length > 0) {
        for (var i = 0; i < data.children.length; i++) { data.children[i] = this.initTreeViewData(data.children[i]) }
      }
      return data
    },

    async save () {
      // Populate form.
      let mask = this.$refs.maskTreeView.getMask().join('')

      if (this.edit) {
        this.form.creator_id = mask.creator_id
      } else {
        this.form.creator_id = this.user.id
      }
      this.form.form_type = this.formType
      this.form.organization_id = this.user.organization_id
      this.form.mask = mask

      // Send form.

      try {
        if (this.edit) { var { data } = await this.form.patch('/api/evaluations/masks/' + this.mask_id) } else { var { data } = await this.form.post('/api/evaluations/masks') }

        // Hide and reset modal.
        this.hide()
        this.form.title = this.formType + ' - ' + new Date(Date.now()).toDateString()

        this.$emit('saved', data)
      } catch (e) {
        console.error(e)
      }
    },

    show () {
      this.$refs.newMaskModal.show()
    },

    setEdit (state) {
      this.edit = state
    }
  }
}
</script>

<style scoped>
.mask-tree-view {
  max-height: 500px;
  overflow-y: auto  ;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Masks/MaskModal.vue